export default __webpack_public_path__ + "static/media/price.9d312dbf.jpg";